import React from "react";
import { Custom } from "components";
import { useApp } from "context";
import { Box } from "@mui/material";

type Props = {
  sx?: any;
  opened: boolean;
  onClose?: (state: boolean) => void;
  children?: React.ReactNode;
};

export const Consent = (props: Props) => {
  const { t } = useApp();

  const [consentButton, setConsentButton] = React.useState(true);
  const handleScroll = (done: boolean) => setConsentButton(!done);
  const handleOpen = () => setConsentButton(true);

  function handleClose(state: boolean) {
    props.onClose && props.onClose(state);
  }

  return (
    <>
      <Custom.Modal
        header={t.title.consent}
        opened={props.opened}
        footer={
          <Box
            sx={{
              width: "100%",
              display: "flex",
              justifyContent: "space-between",
            }}
          >
            <Custom.Button
              onClick={() => handleClose(false)}
              variant="outlined"
            >
              {t.action.disagree}
            </Custom.Button>
            <Custom.Button
              onClick={() => handleClose(true)}
              disabled={consentButton}
            >
              {t.action.agree_and_close}
            </Custom.Button>
          </Box>
        }
        onScroll={handleScroll}
        onOpen={handleOpen}
      >
        <>{props.children}</>
      </Custom.Modal>
    </>
  );
};
